/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CHECK_PAYMENT_FROM_FAC } from "../graphql/checkoutFAC.mutation";
import { VApplication } from "../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface CreatePayFACProps {
  amount: number;
  currency?: string;
  notes?: string;
  payOrder?: boolean;
  mode?: string;
}
export interface ICreatePayFACMethods extends IPluginMethodMap {
  createPayFAC(args: any): Promise<any>;
}

export class CreatePayFACService implements IAgentPlugin {
  readonly methods: ICreatePayFACMethods;

  constructor() {
    this.methods = {
      createPayFAC: this.createPayFAC.bind(this),
    };
  }

  async createPayFAC(args: any) {
    const graphqlModule = getGraphQLModule();
    console.log("args44print", args);
    const client = graphqlModule.getClient("graphql-gateway");
    if (args?.event?.payOrder === null || args?.event?.payOrder === undefined) {
      throw Error("Pay order cannot be null or empty");
    }
    let variables: any = {
      data: {
        cardDetail: {
          cardExp: args?.event?.expiry,
          cardHolderName: args?.event?.name,
          cardPan: (args?.event?.number || "").replace(/\s+/g, ""),
          cvv: args?.event?.cvc,
        },
        currency: args?.event?.currency,
        // tax: uuidv4(),
        totalAmount: parseFloat(args?.event?.amount),
        payOrder: args?.event?.payOrder,
        platformFee: args?.event?.platformFee
          ? parseFloat(args?.event?.platformFee)
          : 0,
        allocations: args?.event?.allocations ?? [],
      },
    };
    if (args?.event?.code) {
      variables = {
        ...variables,
        data: {
          ...variables?.data,
          discountCode: args?.event?.code,
        },
      };
    }
    if (args?.event?.myEmail) {
      variables = {
        ...variables,
        data: {
          ...variables?.data,
          email: args?.event?.myEmail,
        },
      };
    }
    if (args?.event?.phone) {
      variables = {
        ...variables,
        data: {
          ...variables?.data,
          phoneNumber: args?.event?.phone,
        },
      };
    }
    console.log(variables);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: CHECK_PAYMENT_FROM_FAC,
          variables: variables,
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}